import React from "react";
import InfoSection from "@components/pages/info/info_section";

function ServiceNumber() {
    return (
        <>
            <InfoSection title="Opnunartímar þjónustuvers 1819">
                <p>Virkir dagar - 08:00 til 18:00</p>
                <p>Helgar - 10:00 til 18:00</p>
            </InfoSection>
            <InfoSection title="Opnunartímar skrifstofu 1819">
                <p>Virkir dagar - 09:00 til 17:00</p>
                <p>Helgar - Lokað</p>
            </InfoSection>
        </>
    );
}
export default ServiceNumber;
